export { default } from "./FlightCard.jsx"
